import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../contexts/AuthContext';

const Register = () => {
  const navigate = useNavigate();
  const { register } = useAuth();
  
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    password: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // التحقق من تطابق كلمة المرور
    if (formData.password !== formData.confirmPassword) {
      setError('كلمة المرور غير متطابقة');
      setLoading(false);
      return;
    }

    // التحقق من طول كلمة المرور
    if (formData.password.length < 6) {
      setError('كلمة المرور يجب أن تكون 6 أحرف على الأقل');
      setLoading(false);
      return;
    }

    const result = await register({
      first_name: formData.first_name,
      last_name: formData.last_name,
      email: formData.email,
      phone: formData.phone,
      password: formData.password
    });
    
    if (result.success) {
      navigate('/');
    } else {
      setError(result.error);
    }
    
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center p-4" dir="rtl">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md"
      >
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="w-20 h-20 mx-auto mb-4 rounded-full overflow-hidden border-2 border-[#00E5FF]/30">
            <img
              src="https://customer-assets.emergentagent.com/fe0d89dd-7220-47e5-8912-618386cce67e/DALL%C2%B7E%202025-01-28%2017.56.37%20-%20A%20modern,%20professional%20logo%20representing%20a%20trading%20signals%20platform.%20The%20logo%20features%20the%20Arabic%20word%20'%D8%A7%D9%84%D8%B1%D8%A4%D9%8A%D9%87'%20(Al-Ruya)%20in%20a%20sleek,%20stylized%20fon.webp"
              alt="ALROYAH"
              className="w-full h-full object-cover"
            />
          </div>
          <h1 className="text-2xl font-bold text-white">الرؤية للتداول</h1>
          <p className="text-zinc-400 mt-2">إنشاء حساب جديد</p>
        </div>

        {/* Form */}
        <div className="glass-panel p-6 rounded-lg">
          <form onSubmit={handleSubmit} className="space-y-4">
            {error && (
              <div className="bg-red-500/10 border border-red-500/30 text-red-400 p-3 rounded-lg text-sm text-center">
                {error}
              </div>
            )}

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-zinc-400 text-sm mb-2">الاسم الأول</label>
                <input
                  type="text"
                  name="first_name"
                  value={formData.first_name}
                  onChange={handleChange}
                  required
                  className="w-full bg-black/50 border border-white/10 rounded-lg px-4 py-3 text-white focus:border-[#00E5FF] focus:outline-none transition-colors"
                  placeholder="محمد"
                  data-testid="register-first-name"
                />
              </div>
              <div>
                <label className="block text-zinc-400 text-sm mb-2">الاسم الأخير</label>
                <input
                  type="text"
                  name="last_name"
                  value={formData.last_name}
                  onChange={handleChange}
                  required
                  className="w-full bg-black/50 border border-white/10 rounded-lg px-4 py-3 text-white focus:border-[#00E5FF] focus:outline-none transition-colors"
                  placeholder="أحمد"
                  data-testid="register-last-name"
                />
              </div>
            </div>

            <div>
              <label className="block text-zinc-400 text-sm mb-2">البريد الإلكتروني</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full bg-black/50 border border-white/10 rounded-lg px-4 py-3 text-white focus:border-[#00E5FF] focus:outline-none transition-colors"
                placeholder="example@email.com"
                dir="ltr"
                data-testid="register-email"
              />
            </div>

            <div>
              <label className="block text-zinc-400 text-sm mb-2">رقم الهاتف</label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
                className="w-full bg-black/50 border border-white/10 rounded-lg px-4 py-3 text-white focus:border-[#00E5FF] focus:outline-none transition-colors"
                placeholder="+966 5XX XXX XXXX"
                dir="ltr"
                data-testid="register-phone"
              />
            </div>

            <div>
              <label className="block text-zinc-400 text-sm mb-2">كلمة المرور</label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                minLength={6}
                className="w-full bg-black/50 border border-white/10 rounded-lg px-4 py-3 text-white focus:border-[#00E5FF] focus:outline-none transition-colors"
                placeholder="••••••••"
                dir="ltr"
                data-testid="register-password"
              />
            </div>

            <div>
              <label className="block text-zinc-400 text-sm mb-2">تأكيد كلمة المرور</label>
              <input
                type="password"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                required
                minLength={6}
                className="w-full bg-black/50 border border-white/10 rounded-lg px-4 py-3 text-white focus:border-[#00E5FF] focus:outline-none transition-colors"
                placeholder="••••••••"
                dir="ltr"
                data-testid="register-confirm-password"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#00E5FF] hover:bg-[#00E5FF]/80 text-black font-bold py-3 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              data-testid="register-submit"
            >
              {loading ? 'جاري إنشاء الحساب...' : 'إنشاء حساب'}
            </button>
          </form>

          <div className="mt-6 text-center">
            <p className="text-zinc-400">
              لديك حساب بالفعل؟{' '}
              <Link to="/login" className="text-[#00E5FF] hover:underline">
                تسجيل الدخول
              </Link>
            </p>
          </div>
          
          {/* رابط الشروط والأحكام */}
          <div className="mt-4 text-center">
            <p className="text-zinc-500 text-xs">
              بإنشاء حساب، فإنك توافق على{' '}
              <Link to="/terms" className="text-[#00E5FF] hover:underline">
                الشروط والأحكام وإخلاء المسؤولية
              </Link>
            </p>
          </div>
        </div>

        {/* Footer */}
        <p className="text-center text-zinc-500 text-xs mt-6">
          © 2025 الرؤية للتداول. جميع الحقوق محفوظة.
          <br />
          <a href="mailto:support@alroyah.com" className="text-zinc-500 hover:text-[#00E5FF] transition-colors">
            support@alroyah.com
          </a>
        </p>
      </motion.div>
    </div>
  );
};

export default Register;
